import React from "react";
import { Link } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { fmt } from "@/lib/constants";
import { utilTone, utilBar } from "@/components/debts/CreditUtilization";
import HelpTip from "@/components/HelpTip";

export default function UtilizationKPI({ credit, compact }) {
  const u = credit?.total_utilization;
  const tone = utilTone(u);
  const valueSize = compact ? "text-xl" : "text-2xl";
  return (
    <Link to="/debts" data-testid="kpi-utilization" className={`${compact ? "p-4" : "p-5"} rounded-2xl border border-border bg-card relative overflow-hidden group hover:-translate-y-0.5 transition-all block`}>
      <div className={`absolute -top-10 -right-10 h-32 w-32 rounded-full bg-gradient-to-br from-current/20 to-transparent blur-2xl opacity-60 ${tone || "text-muted-foreground"}`} />
      <div className={`${compact ? "h-8 w-8" : "h-9 w-9"} rounded-lg bg-accent flex items-center justify-center ${tone}`}><CreditCard className="h-4 w-4" /></div>
      <div className={`${compact ? "mt-2.5" : "mt-3"} text-[10px] uppercase tracking-wider text-muted-foreground font-semibold flex items-center gap-1`}>Credit utilization <HelpTip k="utilization" /></div>
      {u == null ? (
        <>
          <div className={`mt-1 font-display ${valueSize} font-extrabold font-mono tracking-tight`}>—</div>
          <div className="text-xs text-muted-foreground mt-0.5">Add a card with a limit</div>
        </>
      ) : (
        <>
          <div className={`mt-1 font-display ${valueSize} font-extrabold font-mono tracking-tight ${tone}`} data-testid="kpi-utilization-pct">{u}%</div>
          <div className="mt-2 h-1.5 rounded-full bg-accent overflow-hidden relative">
            <div className={`h-full rounded-full ${utilBar(u)}`} style={{ width: `${Math.min(u, 100)}%` }} />
            <div className="absolute top-0 bottom-0 w-px bg-foreground/40" style={{ left: `${credit.goal_pct}%` }} />
          </div>
          <div className="text-xs text-muted-foreground mt-1">{fmt(credit.total_balance)} of {fmt(credit.total_limit)} · {credit.cards.length} card{credit.cards.length === 1 ? "" : "s"}</div>
          {credit.by_member?.length > 1 && (
            <div className="text-[11px] mt-1.5 flex flex-wrap gap-x-3 gap-y-0.5" data-testid="kpi-utilization-members">
              {credit.by_member.map(m => <span key={m.user_id} className="text-muted-foreground">{m.name.split(" ")[0]} <span className={`font-mono font-semibold ${utilTone(m.total_utilization)}`}>{m.total_utilization}%</span></span>)}
            </div>
          )}
        </>
      )}
    </Link>
  );
}
